module.exports = __webpack_public_path__ + "img/Gauge.cdb4975d.png";